import { render, staticRenderFns } from "./JobMatchResultContainer.vue?vue&type=template&id=73613dc8&lang=pug&"
import script from "./JobMatchResultContainer.vue?vue&type=script&lang=ts&"
export * from "./JobMatchResultContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73613dc8')) {
      api.createRecord('73613dc8', component.options)
    } else {
      api.reload('73613dc8', component.options)
    }
    module.hot.accept("./JobMatchResultContainer.vue?vue&type=template&id=73613dc8&lang=pug&", function () {
      api.rerender('73613dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-match/result-page/JobMatchResultContainer.vue"
export default component.exports